import Vue from 'vue'
import menuOperated from '@/util/menuBtnAuth';
import echarts from 'echarts'
import axios from 'axios';
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../../static/css/common.css';

import api from './apifolder/index'
// 导入所有需要添加到全局的过滤器
import * as filters from '../components/common/js/filters'

// menuOperated.getMenuList(); // 获取菜单数据
function vuePrototype() {
  // Vue.use(ElementUI);
  Vue.config.productionTip = false;
  Vue.prototype.eventHub = new Vue();
  Vue.prototype.$echarts = echarts
  Vue.prototype.axios = axios;
  Vue.prototype.$api = api
  Vue.prototype.$btnAuth = menuOperated.$btnAuth; // 绑定权限点校验方法
  // 将所有过滤器添加到全局
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
  })
}

export default vuePrototype
